import { render, staticRenderFns } from "./PricingDiscounts.vue?vue&type=template&id=4fa24cc4&scoped=true&"
import script from "./PricingDiscounts.vue?vue&type=script&lang=js&"
export * from "./PricingDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./PricingDiscounts.vue?vue&type=style&index=0&id=4fa24cc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa24cc4",
  null
  
)

export default component.exports